import { Typography } from '@mui/material'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Notify passes</Typography>
    <p>Use this page to send a notification to one pass, selected passes, or all passes matching the current table filters.</p>

    <Typography variant='h5'>Selecting recipients</Typography>
    <ul>
      <li>Click a row to make it the current pass. This enables actions such as notification history.</li>
      <li>Use checkboxes to select several passes. Checked rows use a separate selection from the current row.</li>
      <li>Select all applies to every pass matching the current server-side filters, not only the rows already loaded. The confirmation dialog makes the scope clear before sending.</li>
    </ul>

    <Typography variant='h5'>Sending a notification</Typography>
    <p>Open the notification action from the menu, write a concise message and review the recipient count and credit quote before confirming. Only installed passes can receive wallet notifications; the result will show any passes that could not be notified.</p>

    <Typography variant='h5'>History</Typography>
    <p>Open a pass row or use notification history to review notifications previously sent to that pass.</p>
  </div>
)

export default HelpText
